import { render, staticRenderFns } from "./GeneralTableUserSite.vue?vue&type=template&id=37397024"
import script from "./GeneralTableUserSite.vue?vue&type=script&lang=js"
export * from "./GeneralTableUserSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports